import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useUser } from '../../context/UserContext';

const ProtectedRoute = () => {
    const { user } = useUser();
    const location = useLocation();

    if (!user?.token) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    if (user?.role === 'guest') {
        const path = String(location.pathname || '').toLowerCase();
        if (path === '/chat' || path === '/trips' || path === '/cleanerdashboard') {
            return <Outlet />;
        }
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;